import React, { useState, useEffect, useRef } from "react";
import "./Terminal.css";

const TerminalTest = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [passwordInput, setPasswordInput] = useState("");
    const [incorrectPassword, setIncorrectPassword] = useState(false);
    const correctPassword = process.env.REACT_APP_CORRECT_PASSWORD;

    // Password sound effects
    const audioWrong = new Audio("/sounds/wrPsswrd.wav");
    const audioCorrect = new Audio("/sounds/crPsswrd.wav");

    // Initial password checking function
    const handlePasswordSubmit = (e) => {
        e.preventDefault();
        if (passwordInput === correctPassword) {
            setIsAuthenticated(true);
            setIncorrectPassword(false);
            if (audioCorrect) {
                audioCorrect.play().catch((err) => console.log("Audio error:", err));
            }
        } else {
            setIncorrectPassword(true);
            setPasswordInput("");
            if (audioWrong) {
                audioWrong.play().catch((err) => console.log("Audio error:", err));
            }
        }
    };

    // Password component
    return (
        <div className="terminal-container">
            {!isAuthenticated ? (
                <div className="password-screen">
                    <h2>Turn 🔊 On</h2>
                    <h2>Enter Password to Access the Terminal</h2>
                    <form onSubmit={handlePasswordSubmit}>
                        <input
                            type="password"
                            value={passwordInput}
                            autoFocus
                            onChange={(e) => setPasswordInput(e.target.value)}
                            placeholder="Enter password..."
                            className="password-input"
                        />
                        <button type="submit" className="submit-btn">
                            Unlock
                        </button>
                    </form>
                    {incorrectPassword && (
                        <p className="error-msg">Incorrect Password! Try again.</p>
                    )}
                </div>
            ) : (
                <TerminalContent />
            )}
        </div>
    );
};

const TerminalContent = () => {
    const encryptionKey = process.env.REACT_APP_ENCRYPTION_KEY;
    const [logs, setLogs] = useState([
        `
▗▄▄▄▗▖  ▗▖▗▄▄▖▗▄▖ ▗▄▄▗▖  ▗▗▄▄▄▗▄▄▄▗▄▖     ▗▄▄▄▗▖  ▗▗▖  ▗▗▄▄▄▖▗▄▄▗▄▄▄▗▄▄▄▖▗▄▄▖▗▄▗▄▄▄▗▄▄▄▖▗▄▖▗▖  ▗▖
  █ ▐▛▚▖▐▐▌  ▐▌ ▐▐▌  ▐▛▚▖▐▌ █   █▐▌ ▐▌      █ ▐▛▚▖▐▐▌  ▐▐▌  ▐▌    █   █ ▐▌  ▐▌ ▐▌█   █ ▐▌ ▐▐▛▚▖▐▌
  █ ▐▌ ▝▜▐▌  ▐▌ ▐▐▌▝▜▐▌ ▝▜▌ █   █▐▌ ▐▌      █ ▐▌ ▝▜▐▌  ▐▐▛▀▀▘▝▀▚▖ █   █ ▐▌▝▜▐▛▀▜▌█   █ ▐▌ ▐▐▌ ▝▜▌    
▗▄█▄▐▌  ▐▝▚▄▄▝▚▄▞▝▚▄▞▐▌  ▐▗▄█▄▖ █▝▚▄▞▘    ▗▄█▄▐▌  ▐▌▝▚▞▘▐▙▄▄▗▄▄▞▘ █ ▗▄█▄▝▚▄▞▐▌ ▐▌█ ▗▄█▄▝▚▄▞▐▌  ▐▌

        
      Congratulations on qualifying for the second round! 

-Commands Guide:
   ls                 - List files and directories in the current path.
   pwd                - Show the present working directory.
   cd <foldername>    - Change directory.
   cd ..              - Go back to the previous directory.
   clear              - Clear the terminal screen.
   help               - Display this user guide again.
   cat <filename> <password> - View file contents (some files require a password).


For further assistance, please contact the system administrator.
Created by Mufeez                                                                                         
        `,
    ]);
    const [input, setInput] = useState("");
    const inputRef = useRef(null);
    const [showCursor, setShowCursor] = useState(true);
    const terminalContentRef = useRef(null);
    const audioType = new Audio("/sounds/type.mp3");
    const audioSubmit = new Audio("/sounds/submit.wav");
    const [currentPath, setCurrentPath] = useState(["Marcus_s Desktop"]); // Start at the home directory

    // Virtual File System (VFS)
    // Define the virtual file system
    const vfs = {
        "Marcus_s Desktop": {
            No_Pain: {
                No_Gain: {
                    "Objects_in_Mirror_Are_Buffer_Than_They_Appear.txt":
                        "Objects_in_Mirror_Are_Buffer_Than_They_Appear.txt",
                    "skelter.jpg": "skelter.jpg",
                },
                "my_hero.jpg": "my_hero.jpg",
            },
            Paintings: {
                "image1.png": "image1.png",
                "image2.png": "image2.png",
                "image3.png": "image3.png",
                "image4.png": "image4.png",
                "image5.png": "image5.png",
                "image6.png": "image6.png",
                "image7.png": "image7.png",
                "image8.png": "image8.png",
                "image9.png": "image9.png",
                "image10.png": "image10.png",
                "image11.png": "image11.png",
                "image12.png": "image12.png",
                "image13.png": "image13.png",
                "image14.png": "image14.png",
                "image15.png": "image15.png",
                "the_door.png": "the_door.png",
                "the_key.txt": "the_key.txt",
            },
            Pie: {
                "ReadMeFirst.pdf": "ReadMeFirst.pdf",
                "ReadMeNext.txt": "ReadMeNext.txt",
                "Solver.py": "Solver.py",
            },
            Queen_Victoria: {
                King_Charles: {
                    John_Rook: {
                        Bishop_Desmond_Tutu: {
                            Knight_Lancelot: {
                                WhoAmIMissing: {
                                    "Chess.exe": "Chess.zip",
                                },
                                "tools.jpg": "tools.jpg",
                            },
                            "favmove.png": "favmove.png",
                        },
                        "r.jpg": "r.jpg",
                    },
                    "my_king.jpg": "my_king.jpg",
                },
                "myqueen.jpg": "myqueen.jpg",
            },
            Rabbit_Hole: {
                Tail_White: {
                    Tail_Muddier: {
                        Tail_Brown: {
                            "helter.jpg": "helter.jpg",
                        },
                    },
                },
            },
            "accross_and_down.txt": "accross_and_down.txt",
            "Email_Log.txt": "Email_Log.txt",
            "nwod_dna_ssorcca.txt": "nwod_dna_ssorcca.txt",
            "Pie_Code.png": "Pie_Code.png",
            "Numpad.exe": "Numpad.zip",
        },
    };

    const passwords = {
        Pie: "DOUGHNUT",
        WhoAmIMissing: "PAWN",
    };

    const filepasswords = {
        "Objects_in_Mirror_Are_Buffer_Than_They_Appear.txt": "OXINGSGXEK",
    };


    // Get the current directory based on the path
    const getCurrentDir = () => {
        return currentPath.reduce((acc, key) => acc[key], vfs);
    };

    // Handle commands
    const handleCommand = (command, args) => {
        switch (command) {
            case "ls":
                return listFiles();
            case "pwd":
                return "/" + currentPath.join("/");
            case "cd":
                return changeDirectory(args?.[0], args?.[1]);
            case "clear":
                return "CLEAR_TERMINAL";
            case "help":
                return userGuide();
            case "cat":
                return openFile(args?.[0], args?.[1]);
            default:
                return `Invalid Command: ${command}`;
        }
    };

    // List files in the current directory
    const listFiles = () => {
        const dir = getCurrentDir();
        return Object.keys(dir).join("    ");
    };

    // Change directory
    const changeDirectory = (dirName, password) => {
        if (!dirName) return "Please specify a directory name.";

        if (dirName === "..") {
            if (currentPath.length > 1) {
                setCurrentPath((prev) => prev.slice(0, -1));
                return `Moved up to /${currentPath.slice(0, -1).join("/")}`;
            }
            return "Already in the parent directory.";
        }

        const dir = getCurrentDir();

        if (!dir || !dir[dirName]) return `No such directory: ${dirName}`;
        if (typeof dir[dirName] !== "object") return `${dirName} is not a directory.`;

        if (passwords[dirName]) {
            if (!password) return `Password required for ${dirName}.`;
            if (passwords[dirName] !== password) return `Incorrect password for ${dirName}.`;
        }

        setCurrentPath((prev) => [...prev, dirName]);
        // currentPath.push(dirName);
    return `Changed directory to /${[...currentPath, dirName].join("/")}`;
    };

    // Open file
    const openFile = (file, password) => {
        const dir = getCurrentDir();
        if (!file.includes(".")) return `Enter the correct filename with extension.`;
        if (!dir[file]) return `File not found: ${file}`;
        if (filepasswords[file] && filepasswords[file] !== password) return "Incorrect password!";
        return `OPEN_FILE ${file}`;
    };

    // User guide
    const userGuide = () => {
        return `
-Commands Guide:
   ls                 - List files and directories in the current path.
   pwd                - Show the present working directory.
   cd foldername      - Change directory.
   cd ..              - Go back to the previous directory.
   clear              - Clear the terminal screen.
   help               - Display this user guide again.
   cat filename password - View file contents (some files require a password).

For further assistance, please contact the system administrator.
Created by Mufeez!
`;
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        if (input.trim()) {
            const [command, ...args] = input.trim().split(" ");
            const response = handleCommand(command, args);
            if (typeof response === "string") {
                setLogs((prev) => [...prev, `$ ${input}`, response]);
                setInput("");
                if (response.startsWith("OPEN_FILE")) { 
                    let filename = response.split(" ")[1];
                    let ext = filename.split(".")[1];
                    filename = filename.split(".")[0];
                    const updatedName = encrypt(filename, encryptionKey);

                    if (ext === "exe") {
                        const a = document.createElement("a");
                        a.href = `/GDVAQZ/${updatedName}.zip`;
                        a.download = `${updatedName}.zip`; 
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    } else {
                        window.open(`/GDVAQZ/${updatedName}.${ext}`, "_blank");
                    }
                }
                } else {
                    setLogs((prev) => [...prev, `$ ${input}`, response]);
                    setInput("");
                }

            if (audioSubmit) {
                audioSubmit.play().catch((err) => console.log("Audio error:", err));
            }
            if (input.trim().toLowerCase() === "clear") {
                setLogs([]);
                setInput("");
                return;
            }
        }
    };

    // Handle input change
    const handleInputChange = (e) => {
        setInput(e.target.value);

        if (audioType) {
            audioType.play().catch((err) => console.log("Audio error:", err));
        }
    };
    function encrypt(text, key) {
        let encryptedText = "";
        for (let i = 0; i < text.length; i++) {
            let charCode = text.charCodeAt(i);
            let keyCode = key.charCodeAt(i % key.length);
            let encryptedChar = (charCode ^ keyCode).toString(16).padStart(4, "0");
            encryptedText += encryptedChar;
        }
        // console.log(encryptedText);
        return encryptedText;
    }
    // Cursor and focus management
    useEffect(() => {
        const cursorInterval = setInterval(() => {
            setShowCursor((prev) => !prev);
        }, 500);

        const keepFocus = () => inputRef.current?.focus();
        ["click", "keydown", "mousemove", "touchstart"].forEach((event) =>
            document.addEventListener(event, keepFocus)
        );

        if (terminalContentRef.current) {
            terminalContentRef.current.scrollTop = terminalContentRef.current.scrollHeight;
        }

        return () => {
            clearInterval(cursorInterval);
            ["click", "keydown", "mousemove", "touchstart"].forEach((event) =>
                document.removeEventListener(event, keepFocus)
            );
        };
    }, [logs]);

    return (
        <div className="terminal-content" ref={terminalContentRef}>
            {logs.map((log, index) => (
                <div key={index} className="terminal-log">
                    {log}
                </div>
            ))}
            <form onSubmit={handleSubmit} className="terminal-input">
                <span className="prompt">$ </span>
                <span className="input-text">{input}</span>
                <span className={`cursor ${showCursor ? "blink" : ""}`}>█</span>
                <input
                    ref={inputRef}
                    type="text"
                    value={input}
                    onChange={handleInputChange}
                    autoFocus
                    className="terminal-input-field"
                />
            </form>
        </div>
    );
};

export default TerminalTest;